(() => {
  'use strict';
  const url = new URL(window.location.href);
  const assistId = url.searchParams.get('assist_id');
  if (!/^UPV-[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{6,10}$/.test(assistId || '')) return;

  try { sessionStorage.setItem('upvcAssistId', assistId); } catch (_) { /* Attribution still continues without storage. */ }

  fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ attributes: { __assist_id: assistId, __assist_channel: 'whatsapp' } })
  }).then((response) => {
    if (!response.ok) throw new Error('Cart attribution request failed');
    const clean = new URL(window.location.href);
    const variant = clean.searchParams.get('variant');
    clean.search = '';
    if (variant && /^\d+$/.test(variant)) clean.searchParams.set('variant', variant);
    history.replaceState(history.state, '', `${clean.pathname}${clean.search}${clean.hash}`);
    window.Shopify?.analytics?.publish?.('upvc_help:assist_link_return', { assist_id: assistId, landing_path: clean.pathname });
  }).catch((error) => console.warn('UPVCSTORE assist attribution was not attached', error));
})();
